import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cgu',
  templateUrl: './cgu.component.html',
  styleUrls: ['./information.component.css']
})
export class CGUComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
